import React, { useState, useEffect, useContext } from 'react';
import { Form, Button, Container } from 'react-bootstrap';
import UserContext from '../UserContext';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

export default function AddProduct() {
  const history = useHistory();
  const { user } = useContext(UserContext);

  const [image, setImage] = useState('');
  const [name, setName] = useState('');
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState(0);
  const [countInStock, setCountInStock] = useState(0);

  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (
      image !== '' &&
      name !== '' &&
      brand !== '' &&
      description !== '' &&
      price !== 0 &&
      countInStock !== 0
    ) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [image, name, brand, description, price, countInStock]);

  async function AddProduct(e) {
    e.preventDefault();

    // let response = await fetch(
    //   'https://sheltered-badlands-71188.herokuapp.com/api/v1/product/addproduct2',
    //   {
    //     method: 'POST',
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    //     },
    //   }
    // );
    // if (response.ok) {
    //   let data = await response.json();
    //   console.log(data);
    // } else {
    //   alert('HTTP-Error: ' + response.status);
    // }

    fetch(
      'https://sheltered-badlands-71188.herokuapp.com/api/v1/product/addproduct2',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          image: image,
          name: name,
          brand: brand,
          description: description,
          price: price,
          countInStock: countInStock,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data) {
          Swal.fire({
            title: 'Product Created',
            icon: 'success',
          });
          history.push('/shop');
        } else {
          Swal.fire({
            title: 'Product Creation Failed',
            icon: 'error',
          });
        }
      });

    setImage('');
    setName('');
    setBrand('');
    setDescription('');
    setPrice(0);
    setCountInStock(0);
  }

  return (
    <>
      <Container fluid>
        <Form className='addproduct-form' onSubmit={(e) => AddProduct(e)}>
          <h1 className='fontwht-center'>Create Course</h1>
          <Form.Group>
            <Form.Label className='fontwht'>Name:</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter Name of the Product'
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className='fontwht'>Brand:</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter Name of the Product'
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className='fontwht'>Description:</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter Description'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className='fontwht'>Price:</Form.Label>
            <Form.Control
              type='number'
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className='fontwht'>Stock Count:</Form.Label>
            <Form.Control
              type='number'
              value={countInStock}
              onChange={(e) => setCountInStock(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className='fontwht'>Image URL:</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter Image URL'
              value={image}
              onChange={(e) => setImage(e.target.value)}
              required
            />
          </Form.Group>

          {isActive ? (
            <Button className='addprod-btn' type='submit' variant='primary'>
              Submit
            </Button>
          ) : (
            <Button
              className='addprod-btn'
              type='submit'
              variant='primary'
              disabled
            >
              Submit
            </Button>
          )}
        </Form>
      </Container>
    </>
  );
}
